export interface EditorProps<T> {
  id: string;
  className?: string;
  decimalAlignPercent?: number;
  editable?: boolean;
  preReplacedText?: T | null;
  resize?: boolean | "vertical";
  setValue: (ret: T) => void;
  style?: React.CSSProperties;
  textAlignment?: "left" | "center" | "right" | "decimal" | "default";
  value: T;
  [key: string]: unknown;
}

export interface EditorDefns<T> {
  Editor: (props: EditorProps<T>) => React.ReactElement;
  blankT: T;
  getTextFromT: (text: T) => string[];
  joinTintoBlock: (lines: T[]) => T;
  replaceTextInT: (s: T, oldPhrase: string, newPhrase: T) => T;
  splitTintoLines: (text: T) => T[];
}
